import thunk from "redux-thunk";
import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import {
    setLocale,
    loadTranslations,
    syncTranslationWithStore,
} from "react-redux-i18n";
import rootReducer from "../reducers/index";
import translation from "../l10n/translation";

const store = createStore(
    rootReducer,
    composeWithDevTools(applyMiddleware(thunk))
);

syncTranslationWithStore(store);
store.dispatch(loadTranslations(translation));
store.dispatch(setLocale("en"));

export default store;